import { supabase } from "../Db_Connections/db_connection";

export async function getAllProjects() {
    const { data, error } = await supabase
        .from("projects")
        .select(`
            *,
            profiles (
                first_name,
                last_name,
                email
            )
        `)
        .order("id", { ascending: false });

    return { data, error };
}

export async function getProjectById(id) {
    const { data, error } = await supabase
        .from("projects")
        .select("*")
        .eq("id", id)
        .single();

    return { data, error };
}

export async function addProject(payload) {
    const insertObj = {
        name: payload.name?.trim(),
        description: payload.description?.trim() || null,
        start_date: payload.start_date || null,
        end_date: payload.end_date || null,
        status: payload.status || "Active",
        team_members: Array.isArray(payload.team_members)
            ? payload.team_members.filter(Boolean)
            : [],
        manager: payload.manager ?? null,
        created_by: payload.created_by ?? null,
        // created_at => DB default
    };

    const { data, error } = await supabase
        .from("projects")
        .insert([insertObj])
        .select()
        .single();

    return { data, error };
}

export async function updateProject(id, payload) {
    const updateObj = {
        name: payload.name?.trim(),
        description: payload.description?.trim() || null,
        start_date: payload.start_date || null,
        end_date: payload.end_date || null,
        status: payload.status,
        team_members: Array.isArray(payload.team_members)
            ? payload.team_members.filter(Boolean)
            : undefined,
        manager: payload.manager ?? null,
        created_by: payload.created_by, // usually unchanged, but allowed if you want
    };

    Object.keys(updateObj).forEach(
        (k) => updateObj[k] === undefined && delete updateObj[k],
    );

    const { data, error } = await supabase
        .from("projects")
        .update(updateObj)
        .eq("id", id)
        .select()
        .single();

    return { data, error };
}

export async function deleteProject(id) {
    const { error } = await supabase.from("projects").delete().eq("id", id);
    return { error };
}